import { CBadge, CButton, CCard, CCardHeader } from '@coreui/react-pro';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { COURSE_DIRECT_PATH, GUEST_PATH, LOCAL_ORG_USER, MY_ORG_PATH, SEAT_STATUS, STATUS, TRAINING_PRODUCT_TYPES } from '../../../../../constants';
import { fetchSubscriberLimitProductEventsRequest } from '../../../../../helpers/handleFunctionGeneral';
import { fetchOrganizationCoursesRequest } from '../../OrganizationCourses/actions';
import { fetchListOrganizationBundleSeatsRequest, fetchListOrganizationSeatsRequest } from '../OrganizationSeats/actions';
import { getFirstSellingGroupProductFromProduct, tryParseJSON } from '../../../../../utils';
import { CenterSpinner } from '../../../../General/Loadings';
import TooltipWithIcon from '../../../../General/Tooltips/TooltipWithIcon';

const TrainingCourse = ({ product }) => {
     const navigate = useNavigate();
     const location = useLocation();
     const { slug, eventId } = useParams();

     const dispatch = useDispatch();
     const listOrganizationSeats = useSelector((state) => state.subscriber.listOrganizationSeats);
     const listOrganizationBundleSeats = useSelector((state) => state.subscriber.listOrganizationBundleSeats);
     const organizationCourses = useSelector((state) => state.subscriber.organizationCourses);

     const locationPath = location.pathname;

     const productId = product?.id;
     const trainingProductType = product.productType?.trainingProductType;
     const isLiveTraining = trainingProductType === TRAINING_PRODUCT_TYPES.LIVE_TRAINING;
     const isBundle = trainingProductType === TRAINING_PRODUCT_TYPES.BUNDLE;

     const listSeatsByType = isBundle ? listOrganizationBundleSeats : listOrganizationSeats;

     const disableAccess =
          trainingProductType === TRAINING_PRODUCT_TYPES.PHYSICAL_PRODUCT &&
          product.quantity !== -1 &&
          (product.quantity < 1 || product.quantity < product.organizationMin);
     let organizationCourse = organizationCourses?.find((orgCourse) => orgCourse.productId === productId);
     let listSeats =
          eventId && isLiveTraining
               ? listSeatsByType?.filter((seat) => seat.productId === productId && seat.eventId === eventId)
               : listSeatsByType?.filter((seat) => seat.productId === productId);

     let purchaseButtonText = 'PURCHASE SEATS';
     let enableProductEvent = true;
     const orgUserLocalStorage = tryParseJSON(localStorage.getItem(LOCAL_ORG_USER));
     const organizationId = orgUserLocalStorage?.organizationId;

     const [productEvents, setProductEvents] = useState([]);

     if (trainingProductType) {
          switch (trainingProductType) {
               case TRAINING_PRODUCT_TYPES.PHYSICAL_PRODUCT:
               case TRAINING_PRODUCT_TYPES.DIGITAL_DOWNLOAD:
               case TRAINING_PRODUCT_TYPES.PURCHASE_DIGITAL_DOWNLOAD:
                    purchaseButtonText = 'PURCHASE BOOK';
                    break;
               case TRAINING_PRODUCT_TYPES.LIVE_TRAINING:
                    organizationCourse = organizationCourses?.find(
                         (orgCourse) =>
                              orgCourse.productId === productId && orgCourse.eventId === eventId && orgCourse.event?.isAllowOrganizationManage
                    );

                    enableProductEvent = productEvents.length > 0 ? productEvents.some((event) => event.status === STATUS.ENABLE) : false;
                    listSeats = listSeats?.filter((seat) => seat.eventId === eventId);
                    break;
               default: {
                    break;
               }
          }
     }

     const fetchListOrganizationSeats = () => {
          if (organizationId) {
               dispatch(fetchListOrganizationSeatsRequest(organizationId));
          }
     };
     const fetchListOrganizationBundleSeats = () => {
          if (organizationId) {
               dispatch(fetchListOrganizationBundleSeatsRequest(organizationId));
          }
     };
     const fetchOrganizationCourses = () => {
          if (organizationId && !organizationCourses.length) {
               dispatch(fetchOrganizationCoursesRequest(organizationId));
          }
     };

     useEffect(() => {
          fetchListOrganizationSeats();
          fetchListOrganizationBundleSeats();
          fetchOrganizationCourses();
     }, []); // eslint-disable-line react-hooks/exhaustive-deps

     const fetchProductEvents = () => {
          if (productId) {
               dispatch(
                    fetchSubscriberLimitProductEventsRequest({
                         id: productId,
                         organizationId,
                         setFunction: setProductEvents,
                    })
               );
          }
     };

     useEffect(() => {
          if (eventId && trainingProductType === TRAINING_PRODUCT_TYPES.LIVE_TRAINING) {
               fetchProductEvents();
          }
     }, [productId]); // eslint-disable-line react-hooks/exhaustive-deps

     const listSeatOpen = listSeats?.filter((seat) => seat.status === SEAT_STATUS.OPEN);

     const handleNavigate = () => {
          if (eventId) {
               navigate(
                    MY_ORG_PATH.ORGANIZATIONS_COURSE_CATEGORIES_DETAILS_SEATS_EVENT.replace(':slug', slug)
                         .replace(':courseId', organizationCourse?.id)
                         .replace(':eventId', eventId)
               );
          } else {
               const detailsSeatPath = isBundle
                    ? MY_ORG_PATH.ORGANIZATIONS_COURSE_CATEGORIES_DETAILS_BUNDLE_SEATS
                    : MY_ORG_PATH.ORGANIZATIONS_COURSE_CATEGORIES_DETAILS_SEATS;

               navigate(detailsSeatPath.replace(':slug', slug).replace(':courseId', organizationCourse?.id));
          }
     };

     const handleClickPurchase = () => {
          localStorage.setItem(COURSE_DIRECT_PATH, locationPath);

          const sellingGroupProduct = getFirstSellingGroupProductFromProduct(product.sellingGroupProducts);
          const sellingGroupSlug = sellingGroupProduct?.sellingGroup?.slug;

          if (sellingGroupSlug) {
               navigate(GUEST_PATH.SELLING_GROUPS_DETAIL.replace(':slug', sellingGroupSlug));
          }
     };

     return (
          <div className="training-course">
               <CCard>
                    <CCardHeader className=" d-flex justify-content-between align-items-center">
                         <div className="training-course-content d-flex justify-content-between align-items-center flex-1">
                              <div className="training-course-title fov-content-org fov-content-left d-flex">
                                   <p>
                                        <span className={`content-tooltip ${product.seatManageSubheadline ? 'has-subheadline' : ''}`}>
                                             {product.seatManageHeadline || product.publishName}
                                        </span>
                                        {product.seatManageSubheadline && <span className="subheadline">{product.seatManageSubheadline}</span>}
                                        {product.seatManageDescription && (
                                             <TooltipWithIcon content={product.seatManageDescription} trigger="mouseenter focus" />
                                        )}
                                   </p>
                              </div>

                              {!listSeatsByType ? (
                                   <CenterSpinner />
                              ) : (
                                   <div className="training-course-action d-flex">
                                        <CBadge
                                             className={`badge-pill badge-outline-primary ${
                                                  organizationCourse ? 'manage-seat-org' : 'badge-seat-org'
                                             }`}
                                        >
                                             {listSeats?.length > 0 ? `${listSeatOpen?.length} OPEN / ${listSeats?.length} SEATS` : 'NO SEATS'}
                                        </CBadge>

                                        <div className="group-manage-seat d-flex align-items-center">
                                             {organizationCourse && listSeats?.length > 0 ? (
                                                  <CButton
                                                       className="btn btn-blue-highlight purchase-seats-org btn-arrow-right"
                                                       disabled={disableAccess}
                                                       onClick={handleNavigate}
                                                  >
                                                       MANAGE SEATS
                                                  </CButton>
                                             ) : (
                                                  <button className="no-seats-org" hidden></button>
                                             )}

                                             {product.preventPurchase ? (
                                                  <div className="prevent-purchase-text">
                                                       <p className="text-secondary mb-0">
                                                            {product.preventPurchaseText || 'This product is not available now'}
                                                       </p>
                                                  </div>
                                             ) : (
                                                  <CButton
                                                       className="btn btn-blue-dark purchase-seats-org btn-arrow-right"
                                                       onClick={handleClickPurchase}
                                                       disabled={disableAccess || !enableProductEvent}
                                                  >
                                                       {purchaseButtonText}
                                                  </CButton>
                                             )}
                                        </div>
                                   </div>
                              )}
                         </div>
                    </CCardHeader>
               </CCard>
          </div>
     );
};

export default TrainingCourse;
